import { textStyles } from '@asa/asasqt-microfrontend-components/dist/theme/foundations/textStyles';

export const overWrittenTextStyles = {
  ...textStyles,
  body: {
    ...textStyles.body,
    fontSize: ['15px'],
  },
};
